module.exports = __webpack_public_path__ + "static/tiefling_warlock_talisman-a7a9648fa1132fa9ac9b007d105d4c5c.png";